export const APP_NAME = "Yara";
export const APP_TAGLINE = "Meaningful Connections";
export const MAX_PHOTOS = 11;

export const INTERESTS = [
  "Arts / Crafts", "Athletics", "Baha'i History", "Computers / Internet", "Core Activities",
  "Food and Cooking", "Hiking / Camping", "Literature / History", "Nature", "Pioneering",
  "Serving the Faith", "Studying the Writings", "Teaching the Faith", "Travel", "Volunteer / Charity",
  "Yoga / Meditation", "Youth Activities"
];

export const GENDERS = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
] as const;

export const MARITAL_STATUSES = [
  { value: "never_married", label: "Never Married" },
  { value: "divorced", label: "Divorced" },
  { value: "widowed", label: "Widowed" },
] as const;

export const WANTS_CHILDREN_OPTIONS = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
  { value: "not_sure", label: "Not Sure" },
] as const;

export const SMOKING_OPTIONS = [
  { value: "never", label: "Never" },
  { value: "occasionally", label: "Occasionally" },
  { value: "daily", label: "Daily" },
  { value: "trying_to_quit", label: "Trying to quit" },
  { value: "quit", label: "Quit" },
] as const;

export const DRINKING_OPTIONS = [
  { value: "never", label: "Never" },
  { value: "socially", label: "Socially" },
  { value: "daily", label: "Daily" },
  { value: "trying_to_quit", label: "Trying to quit" },
  { value: "quit", label: "Quit" },
] as const;

export const FOOD_PREFERENCES = [
  { value: "all_foods", label: "All foods" },
  { value: "vegetarian", label: "Vegetarian" },
  { value: "vegan", label: "Vegan" },
] as const;

export const EDUCATION_LEVELS = [
  { value: "high_school", label: "High School" },
  { value: "some_college", label: "Some College" },
  { value: "bachelors", label: "Bachelor's Degree" },
  { value: "masters", label: "Master's Degree" },
  { value: "doctorate", label: "Doctorate" },
  { value: "other", label: "Other" },
] as const;

/** Ranked levels only — used for minimum-education preferences (not profile "Other"). */
export const MIN_EDUCATION_LEVELS = EDUCATION_LEVELS.filter((level) => level.value !== "other");

export const RELIGIONS = [
  { value: "bahai", label: "Baha'i" },
  { value: "interested:Christianity", label: "Interested - Christianity" },
  { value: "interested:Islam", label: "Interested - Islam" },
  { value: "interested:Spiritual", label: "Interested - Spiritual" },
  { value: "interested:Other", label: "Interested - Other" },
] as const;

export const LANGUAGE_LEVELS = [
  { value: "fluent", label: "Fluent" },
  { value: "conversational", label: "Conversational" },
  { value: "basic", label: "Basic" },
] as const;

export const COMMON_LANGUAGES = [
  "Arabic",
  "Bengali",
  "Chinese",
  "English",
  "French",
  "German",
  "Hindi",
  "Italian",
  "Japanese",
  "Korean",
  "Persian",
  "Portuguese",
  "Russian",
  "Spanish",
  "Swahili",
  "Turkish",
  "Urdu",
] as const;
